import * as customer from './customer/customer.reducer'
import { userReducer as user } from 'shared-lib'

export { user, customer }
